import { DSCircularButton } from "@components/design-system/molecules";
import { faPaw } from "@fortawesome/pro-solid-svg-icons";
import { useNavigate, useLocation } from "react-router";

import Paw from "../../assets/imgs/paw.svg?react";
import { useWindowDimensions } from "../../hooks";
import { EditablePatientModal as CreatePatientModal } from "./modal/EditablePatientModal";

function NewPatient({
  isForPatientSelectionAction = false,
  setSelectedPatientName,
  setSelectedPatientUuid,
  shouldShow,
  setShouldShow,
  onAddPatient,
  dataTestId,
}) {
  const { width } = useWindowDimensions();

  const navigate = useNavigate();
  const location = useLocation();

  const isForPatientNoteCreation =
    location.pathname === "/new_note/select";

  function redirectToNotebook(uuid) {
    setShouldShow(!shouldShow);

    if (!isForPatientSelectionAction && !isForPatientNoteCreation) {
      navigate(`/notebook/${uuid}`);
    }
  }

  function hideModal() {
    setShouldShow(false);
  }

  const createProps = {
    shouldShow,
    redirectToNotebook,
    hideModal,
    isForPatientSelectionAction,
    isForPatientNoteCreation,
    setSelectedPatientName,
    setSelectedPatientUuid,
    onAddPatient,
  };

  const shouldShowSmallButton =
    width < 800 || isForPatientNoteCreation;

  return (
    <div>
      {shouldShowSmallButton ? (
        <DSCircularButton
          size="md"
          icon={faPaw}
          dataTestId={dataTestId ?? "newPatient"}
          onClick={() => setShouldShow(true)}
        />
      ) : (
        <DSCircularButton
          size="xxl"
          icon={faPaw}
          dataTestId={dataTestId ?? "newPatient"}
          onClick={() => setShouldShow(true)}
        >
          <div className="flex flex-col items-center justify-center">
            <Paw className="w-20 mb-2" />
            <span className="text-center text-white text-sm">
              New Patient
            </span>
          </div>
        </DSCircularButton>
      )}

      <CreatePatientModal {...createProps} />
    </div>
  );
}

export default NewPatient;
